const postMessageToClient = (objCall: any) => {
    const dataObj = JSON.stringify(objCall);
    window.parent.postMessage(dataObj, '*');   
}

export {
    postMessageToClient
}